import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Button, Grid } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import axios from '../api/axios';

const HeroSection = () => {
  const [settings, setSettings] = useState({
    heroTitle: 'Консультационный центр "Волшебная страна"',
    heroSubtitle: 'Национальный проект «Образование»',
    heroDescription: 'В рамках реализации национального проекта «Образование»...',
    heroImage: '',
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get('/settings/public');
      setSettings(response.data);
    } catch (error) {
      console.error('Ошибка загрузки настроек:', error);
    }
  };

  const handleScroll = (id) => {
    const element = document.querySelector(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #00ACC1 0%, #81C784 50%, #C5E1A5 100%)',
        minHeight: { xs: '70vh', md: '80vh' },
        color: 'white',
        py: { xs: 8, md: 15 },
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {/* Фоновое изображение стопки книг - скрыто на мобильных */}
      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          backgroundImage: 'url(/img/4c31192aa23d7e0b7290914b610f3f6b_1422x1107.9284103154.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center right',
          backgroundRepeat: 'no-repeat',
          filter: 'drop-shadow(0 8px 32px rgba(0,0,0,0.15))',
          zIndex: 1,
        }}
      />

      {/* Градиентный overlay для лучшей читаемости текста - только на десктопе */}
      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(90deg, rgba(0,172,193,0.8) 0%, rgba(0,172,193,0.4) 60%, rgba(0,172,193,0) 100%)',
          zIndex: 2,
        }}
      />
      
      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 3 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={7}>
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '1.3rem', sm: '2rem', md: '3.5rem' },
                fontWeight: 700,
                mb: 3,
                lineHeight: 1.2,
                textAlign: { xs: 'center', md: 'left' },
                textShadow: { xs: '0 2px 10px rgba(0,0,0,0.2)', md: '0 4px 20px rgba(0,0,0,0.3)' },
                maxWidth: '100%',
                overflow: 'hidden',
                px: { xs: 1, md: 0 },
              }}
            >
              <Box component="span" sx={{ display: 'block', whiteSpace: { xs: 'normal', sm: 'nowrap' }, maxWidth: '100%' }}>
                Консультационный{'\u00A0'}центр
              </Box>
              <Box component="span" sx={{ display: 'block', whiteSpace: { xs: 'normal', sm: 'nowrap' }, maxWidth: '100%' }}>
                "Волшебная{'\u00A0'}страна"
              </Box>
            </Typography>
            <Typography
              variant="h5"
              sx={{
                mb: 4,
                opacity: 0.95,
                fontWeight: 400,
                lineHeight: 1.5,
                fontStyle: 'italic',
                maxWidth: { xs: '100%', md: 700 },
                textAlign: { xs: 'center', md: 'left' },
                fontSize: { xs: '0.75rem', sm: '0.9rem', md: '1.5rem' },
                px: { xs: 1, md: 0 },
              }}
            >
              Муниципальное{'\u00A0'}автономное{'\u00A0'}дошкольное{'\u00A0'}образовательное{'\u00A0'}учреждение{'\u00A0'}
              муниципального{'\u00A0'}образования{'\u00A0'}города{'\u00A0'}Краснодар «Детский{'\u00A0'}сад{'\u00A0'}№{'\u00A0'}213»
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSection;
